import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Menu, X } from 'lucide-react';
import Sidebar from "./Sidebar";
import Headerbar from "./Headerbar";
import FlowAssistant from "../components/FlowAssistant";
import ConsentModal from "../components/modal/ConsentModal";


const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();

  // Cierra el menú móvil al cambiar de página (para que navegar "se sienta" que funciona).
  useEffect(() => { setIsSidebarOpen(false); }, [location.pathname]);

  return (
    <div className="flex h-screen overflow-hidden relative">
      {/* Toggle Button for mobile — pegado al borde izquierdo cuando esta cerrado; junto al menu cuando abierto */}
      <button
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        style={{ top: 'calc(env(safe-area-inset-top, 0px) + 0.75rem)' }}
        className={`lg:hidden fixed z-[60] w-11 h-11 flex items-center justify-center bg-[#092F7B] hover:bg-[#0a2540] text-white shadow-lg cursor-pointer rounded-full transition-all duration-300 ${
          isSidebarOpen ? 'left-[13rem]' : 'left-3'
        }`}
        aria-label={isSidebarOpen ? 'Cerrar menú' : 'Abrir menú'}
      >
        {isSidebarOpen ? <X size={22} /> : <Menu size={22} />}
      </button>


      {/* Sidebar */}
      <div className={`
          absolute lg:relative z-40 top-0 left-0 h-full w-65 fx-shell-side bg-white border-r border-[#E9EAEB] shadow-md transition-transform duration-300
          ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}
          lg:translate-x-0
        `}
      >
        <Sidebar />
      </div>

      {/* Overlay for mobile — fondo oscurecido; tocar fuera cierra el menú */}
      {isSidebarOpen && (
        <div onClick={() => setIsSidebarOpen(false)}
          className="fixed inset-0 bg-black/30 z-30 lg:hidden"
        ></div>
      )}

      {/* Main Content */}
      <div className="flex-1 overflow-x-hidden overflow-y-auto fx-shell-main">
        <Headerbar />
        <Outlet />
      </div>

      {/* Flow — Asistente conversacional disponible en todas las páginas */}
      <FlowAssistant />

      {/* Consentimiento de WhatsApp — aparece una vez si el cliente no ha decidido */}
      <ConsentModal />
    </div>
  );
};

export default Layout;
